import { createRoot } from "react-dom/client";

import App from "./app";
import { initGTMIfEnabled } from "./utils/gtm";

// Initialize GTM based on environment variables
initGTMIfEnabled();

const container = document.getElementById("container");
const root = createRoot(container!);
root.render(<App />);
